import React, { useState, useEffect } from "react";
import useQuery from "../../utils/useQuery";
import { getSummary } from "../../services/summaryService";
import { isEmptyObj } from "../../utils/siteUtils";
import { initialLogic } from "../../services/productService";
import { isBizNull } from "../../utils";
import CheckoutErrorView from "../checkout-error-view/index";
import PreSalesCheckoutViewInStore from "../presales-checkout-view-in-store";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { clubSelector, selectUserState } from "../../selectors/application";
import { becomeAMemberSummary } from "../../redux/actions/becomeAMember";
import { getApiError } from "../../services/siteService";

const PreSalesCheckoutInStore = props => {
  const {
    fields: { hero, billingInfo, cardInfo, summary, newAddressLabel, delivery, defaultRedirect, confirmationUrl },
    lang,
    becomeAMemberSummary,
    setBecomeAMemberSummary,
    user,
    club,
    page,
    match
  } = props;
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);
  const query = useQuery();
  const history = useHistory();
  const summaryData = getSummary(summary[0], becomeAMemberSummary);
  const [selectSummary, setSelectSummary] = useState(summaryData);
  const handleMessage = message => {
    switch (message.data.action) {
      case "redirect":
        global.location.href = message.data.payload;
      default:
        return;
    }
  };
  useEffect(() => {
    if (query.orderNo && query.code) {
      onError({
        code: query.code
      }).then();
    }
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    //** Measurements */
    window.dataLayer = window.dataLayer || [];
    let _currency = "EUR";
    let _country = lang.indexOf("-") > -1 ? lang.split("-")[1] : "se";
    if (_country === "se") {
      _currency = "SEK";
    }
    let _page = {
      type: page.fields.pageType,
      currency: _currency,
      country: lang
    };
    // console.log("history", history);
    // window.dataLayer.push({
    //   event: "virtualPageview",
    //   virtualPageUrl: history.location.pathname + history.location.search,
    //   virtualPageTitle: "pre_sales_checkout",
    //   page: _page
    // });
  }, []);

  useEffect(() => {
    let defaultRedirectHref = defaultRedirect?.value.href ? defaultRedirect.value.href : `/${lang}`;
    if (!becomeAMemberSummary || !becomeAMemberSummary?.color || isEmptyObj(becomeAMemberSummary?.color)) {
      history.replace(defaultRedirectHref);
    } else {
      initialLogic(lang, becomeAMemberSummary).then(payload => {
        if (!isBizNull(payload) && summary[0]) {
          selectSummary.images = payload.image;
          selectSummary.details.deposit.deposit.value = payload.formattedPrice;
          let selectSummary1 = JSON.parse(JSON.stringify(selectSummary));
          setSelectSummary(selectSummary1);
        }
      });
    }
  }, []);
  const onSummaryChangeCallback = ({ color, engine }) => {
    let data = {
      ...becomeAMemberSummary,
      engine: {
        ...becomeAMemberSummary.engine,
        ...engine
      },
      color: {
        ...becomeAMemberSummary.color,
        ...color
      }
    };
    initialLogic(lang, data).then(payload => {
      if (!isBizNull(payload)) {
        selectSummary.images = payload.image;
        selectSummary.details.deposit.deposit.value = payload.formattedPrice;
        let selectSummary1 = JSON.parse(JSON.stringify(selectSummary));
        setSelectSummary(selectSummary1);
        data.currency = payload.currency;
        data.deposit = payload.deposit;
        setBecomeAMemberSummary(data);
      }
    });
  };
  const onError = async ex => {
    const error = await getApiError(ex?.code);
    if (error) {
      setError(error);
      setShowError(true);
    }
  };
  const errorViewProps = {
    error,
    showError,
    onClose: () => {
      setShowError(false);
    }
  };
  return (
    <React.Fragment>
      {error && <CheckoutErrorView {...errorViewProps} />}
      <PreSalesCheckoutViewInStore
        {...{
          lang,
          hero: hero.fields,
          newAddressLabel,
          billingInfo: billingInfo,
          delivery: delivery,
          cardInfo,
          summary: summary[0] ? selectSummary : null,
          user,
          club,
          confirmationUrl,
          becomeAMemberSummary,
          onSummaryCallback: onSummaryChangeCallback,
          match: match,
          onError: ex => onError(ex)
        }}
      />
    </React.Fragment>
  );
};
const mapStateToProps = state => ({
  user: selectUserState(state),
  club: clubSelector(state),
  becomeAMemberSummary: state.becomeAMemberSummary
});
const mapDispatchToProps = dispatch => ({
  setBecomeAMemberSummary: data => {
    dispatch(becomeAMemberSummary(data));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(PreSalesCheckoutInStore);
